module.exports = __webpack_public_path__ + "static/media/street3.6ce75835.jpg";